import React from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from '../AppHeader';
import styles from './AppLayout.module.css';

const AppLayout = ({
  title,
  subtitle,
  language,
  languageLabel,
  onToggleLanguage,
  logoSrc,
  logoAlt,
  userType,
  showHome,
  homeLabel,
  onHome,
  showLogout,
  logoutLabel,
  onLogout,
  actions,
  notificationSlot,
  headerChildren,
  headerClassName,
  children,
  className = '',
  contentClassName = '',
  contentProps = {},
}) => {
  const layoutClassName = [styles.appLayout, className].filter(Boolean).join(' ');
  const contentClassNames = [styles.content, contentClassName].filter(Boolean).join(' ');
  const content = children !== undefined ? children : <Outlet />;

  return (
    <div className={layoutClassName}>
      <AppHeader
        title={title}
        subtitle={subtitle}
        language={language}
        languageLabel={languageLabel}
        onToggleLanguage={onToggleLanguage}
        logoSrc={logoSrc}
        logoAlt={logoAlt}
        userType={userType}
        showHome={showHome}
        homeLabel={homeLabel}
        onHome={onHome}
        showLogout={showLogout}
        logoutLabel={logoutLabel}
        onLogout={onLogout}
        actions={actions}
        notificationSlot={notificationSlot}
        className={headerClassName}
      >
        {headerChildren}
      </AppHeader>

      <main className={contentClassNames} {...contentProps}>
        {content}
      </main>
    </div>
  );
};

export default AppLayout;
